import { gql } from "@apollo/client"
import { UpsertPaySupplementInput, UpsertPaySupplementPayload } from "@oysterhr/schema"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const MUTATION = gql`
  mutation UpsertPaySupplement(
    $engagementId: String!
    $paySupplementId: String
    $paymentType: PaySupplementAvailablePaymentTypeEnum
    $amount: Float
    $notes: String
    $month: Int
    $year: Int
    $state: PaySupplementStateEnumType
  ) {
    upsertPaySupplement(
      input: {
        engagementId: $engagementId
        paySupplementId: $paySupplementId
        paymentType: $paymentType
        amount: $amount
        notes: $notes
        month: $month
        year: $year
        state: $state
      }
    ) {
      company {
        id
        name
        avatarUrl
        paySupplements {
          collection {
            id
            paymentType
            amount
            amountCurrencyCode
            month
            year
            notes
            createdAt
            updatedAt
          }
        }
      }
      errors
    }
  }
`

export const useUpsertPaySupplement = (
  options?: InjectedOptions<
    { upsertPaySupplement: UpsertPaySupplementPayload },
    UpsertPaySupplementInput
  >,
) =>
  useMutation<{ upsertPaySupplement: UpsertPaySupplementPayload }, UpsertPaySupplementInput>(
    MUTATION,
    options,
  )
